import { lazyPopoutMailReadingPaneUtil } from 'owa-mail-popout-reading-pane/lib/lazyFunctions';
import { popoutProjectionMountedPromise } from 'owa-popout-v2/lib/store/parentStore';
import { convertRestIdToEwsId } from 'owa-identifiers';
import { resolveMailboxFromRouteKey } from 'owa-mailbox-info/lib/resolveMailboxFromRouteKey';
import { getMailboxInfoFromDeeplinkParams } from 'owa-mailbox-info/lib/getMailboxInfoFromDeeplinkParams';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export interface MailReadRouteParameters {
    itemId?: string;
    routeKey?: string;
    domain?: string;
    account?: string;
}

export default async function mailReadRouteHandler(
    parameters: MailReadRouteParameters
): Promise<void> {
    const { itemId, routeKey, domain, account } = parameters;

    if (itemId) {
        // Resolve the target mailbox: prefer Universal Link route key (when flighted),
        // fall back to deeplink params
        const mailboxInfo =
            routeKey && isGlobalFeatureEnabled('acct-resolvemailboxfromroutekey')
                ? resolveMailboxFromRouteKey(routeKey)
                : getMailboxInfoFromDeeplinkParams(
                      account,
                      domain,
                      undefined /*groupAlias*/,
                      undefined /*groupDomain*/,
                      getGlobalSettingsAccountMailboxInfo()
                  );

        // Wait for projections to be ready
        await popoutProjectionMountedPromise;

        // Decode the encoded item id from the URL
        const decodedEwsId = convertRestIdToEwsId(decodeURIComponent(itemId));

        // Call the popout mail reading pane util directly to ensure packages are loaded
        await lazyPopoutMailReadingPaneUtil.importAndExecute(
            decodedEwsId,
            undefined /*conversationId*/,
            undefined /*internetMessageId*/,
            mailboxInfo,
            undefined /*data*/,
            undefined /*freezeDryId*/
        );
    }
}
